var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2229 13.3589C11.5511 14.0645 11.5511 15.2082 12.2229 15.9133C12.8942 16.6189 13.9836 16.6189 14.6549 15.9133C15.3267 15.2076 15.3267 14.0639 14.6549 13.3589C13.9831 12.6538 12.8942 12.6538 12.2229 13.3589ZM13.4386 0.636353C6.07717 0.636353 0.109863 6.90417 0.109863 14.6364C0.109863 22.3685 6.07717 28.6364 13.4386 28.6364C20.8001 28.6364 26.7674 22.3685 26.7674 14.6364C26.7674 6.90417 20.8001 0.636353 13.4386 0.636353ZM20.218 8.99401L16.6725 17.1428C16.501 17.5369 16.2001 17.8529 15.8249 18.033L8.06735 21.7572C7.1725 22.1868 6.25023 21.218 6.65923 20.2781L10.2053 12.1293C10.3768 11.7353 10.6777 11.4192 11.0529 11.2391L18.8104 7.51498C19.7053 7.08595 20.627 8.05409 20.218 8.99401Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCompass);
export default __webpack_public_path__ + "static/media/whiteCompass.6676295a6201e416bfd3786054ab8770.svg";
export { ForwardRef as ReactComponent };